<template>
  <div class="footer">
    <div class="content">
      <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
      <p>批准文号：国新出审[2021]1393号 出版物号：ISBN 978-7-498-09371-4 ICP备案：沪ICP备2021002543号-2A</p>
      <p>版权所有：上海雨玩网络科技有限公司|<span @click="openRegProtocol">用户注册协议</span>|<span @click="openPrivacyProtocol(1)">隐私政策</span>|<span @click="openPrivacyProtocol(2)">儿童隐私政策</span></p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openRegProtocol() {
      window.open('https://sdk.xianyouwan.com/protect/index3.html?body=shyw', '_blank')
    },
    openPrivacyProtocol(type) {
      switch (type) {
        case 1:
          window.open('http://www.yuwanyouxi.com/html/protocol.html', '_blank')
          break
        case 2:
          window.open('https://sdk.xianyouwan.com/protect/index2.html?body=shyw', '_blank')
          break
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 300px;
  background: #000;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding-top: 88px;
  width: 1600px;
  font-family: 'SimSun';
  font-size: 18px;
  color: #abafac;

  p {
    margin: 11px 0;

    span {
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
